module.exports = __webpack_public_path__ + "img/setting-avtive.7228afdc.svg";